import { Link, NavLink } from 'react-router-dom';
import { paths } from '../../routes';
import 'bootstrap/js/dist/collapse';
import './Navbar.scss';

export const Navbar = () => {
  return (
    <nav className='navbar navbar-expand-lg navbar-dark p-lg-0 mb-5'>
      <div className='container'>
        <Link className='fs-4 navbar-brand' to={paths.home}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='icon me-2'
            viewBox='0 0 448 512'
          >
            <path
              fill='currentColor'
              d='M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zm0 464H48V208h352v256zm0-304H48V48h352v112zM108.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm192 96h38.4c6.4 0 12.8-6.4 12.8-12.8V268.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm96-96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm0 96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8z'
            ></path>
          </svg>
          Time <b>Calculators</b>
        </Link>
        <button
          className='navbar-toggler'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#navbarSupportedContent'
          aria-controls='navbarSupportedContent'
          aria-expanded='false'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon'></span>
        </button>
        <div className='collapse navbar-collapse' id='navbarSupportedContent'>
          <ul className='navbar-nav ms-auto my-2 my-lg-0 '>
            <li className='nav-item fw-bold'>
              <NavLink className='nav-link px-2 p-lg-4' to={paths.home} exact>
                Home
              </NavLink>
            </li>
            <li className='nav-item fw-bold'>
              <NavLink className='nav-link px-2 p-lg-4' to={paths['contact-us']}>
                Contact Us
              </NavLink>
            </li>
            <li className='nav-item fw-bold'>
              <NavLink className='nav-link px-2 p-lg-4' to={paths['about-us']}>
                About
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
